// extracted by mini-css-extract-plugin
export default {"menuItem":"manual-mark-icon_menuItem__iZ6t+"};